import {settingsService} from '../services/settingsService'

const getDefaultState = () => {
  return {
    trackingSettings: null
  }
}

const state = getDefaultState()

const mutations = {
  setTrackingSettings(state, trackingSettings) {
    state.trackingSettings = trackingSettings
  }
}

const actions = {
  async loadTrackingSettings({commit}) {
    try {
      const res = await settingsService.getTrackingSettings()
      const trackingSettings = res.data

      commit('setTrackingSettings', trackingSettings)
      return trackingSettings

    } catch (e) {
      console.error('error:', e.error)
    }

  },
  async updateTrackingSettings({state}, {payload}) {
    try {
      if (payload) {
        return await settingsService.updateTrackingSettings(payload.businessUid, payload.data)
      }
    } catch(e) {
      console.error('error:', e.error)
    }
  }
}

const getters = {
  trackingSettings: (state) => state.trackingSettings,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
